// 6.1 
export const TANANYAG_FEJLESZTESEK_OPTIONS = {
    hu: [
    { value: 'uj_tananyag', label: 'Új tananyag' },
    { value: 'tananyag_frissites', label: 'Tananyag-frissítés' },
    { value: 'uj_esettanulmany', label: 'Új esettanulmány' },
    { value: 'modositott_esettanulmany', label: 'Módosított esettanulmány' },
    { value: 'uj_eszkoz', label: 'Új értékelési eszköz' },
    { value: 'digitalis_fejlesztes', label: 'Digitális tartalomfejlesztés' },
    { value: 'nincs_fejlesztes', label: 'Nem történt fejlesztés' }
    ],
    en: [
    { value: 'uj_tananyag', label: 'New teaching materials' },
    { value: 'tananyag_frissites', label: 'Updated teaching materials' },
    { value: 'uj_esettanulmany', label: 'New case studies' },
    { value: 'modositott_esettanulmany', label: 'Revised case studies' },
    { value: 'uj_eszkoz', label: 'New assessment tools' },
    { value: 'digitalis_fejlesztes', label: 'Digital content development' },
    { value: 'nincs_fejlesztes', label: 'No developments implemented' }
    ]
};

// 6.2
export const TANTARGYI_KOHERENCIA_OPTIONS = {
    hu: [
    { value: 'kivalo', label: 'Kiváló - a tantárgyak erősen egymásra épülnek, a tartalom és a módszertan is összehangolt' },
    { value: 'megfelelo', label: 'Megfelelő - kisebb eltérések vannak, de a tanulási útvonal alapvetően koherens' },
    { value: 'reszben_koherens', label: 'Részben koherens - több tárgy esetén nem egyértelmű az egymásra épülés' },
    { value: 'gyenge', label: 'Gyenge - több tantárgy tartalma vagy értékelése nem illeszkedik a szak struktúrájába' },
    { value: 'kritikus', label: 'Kritikus - a koherencia hiánya akadályozza a hallgatói sikerességet' }
    ],
    en: [
    { value: 'kivalo', label: 'Excellent – courses are strongly aligned, with coherent content and methodology' },
    { value: 'megfelelo', label: 'Adequate – minor inconsistencies are present, but the learning pathway is largely coherent' },
    { value: 'reszben_koherens', label: 'Partially coherent – progression between courses is unclear in several cases' },
    { value: 'gyenge', label: 'Weak – the content or assessment of several courses does not align with the programme structure' },
    { value: 'kritikus', label: 'Critical – lack of coherence hinders student success' }
    ]
};

// 6.3
export const AZONOSITOTT_PROBLEMATIPUSOK_OPTIONS = {
    hu: [
    { value: 'tananyagok_atfedesei', label: 'Tananyagok közötti átfedések' },
    { value: 'tananyagok_ismetlodesei', label: 'Tananyagok közötti hiátusok / ismétlődések' },
    { value: 'nem_egyertelmu', label: 'Nem egyértelmű előfeltételek' },
    { value: 'inkonzisztens_modszerek', label: 'Inkonzisztens értékelési módszerek' },
    { value: 'nem_osszehangolt', label: 'Nem összehangolt tanulási kimenetek' },
    { value: 'egyuttmukodes_hianya', label: 'Oktatók közötti együttműködés hiánya' },
    { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
    { value: 'tananyagok_atfedesei', label: 'Overlaps between teaching materials' },
    { value: 'tananyagok_ismetlodesei', label: 'Gaps and/or redundancies in teaching materials' },
    { value: 'nem_egyertelmu', label: 'Unclear prerequisites' },
    { value: 'inkonzisztens_modszerek', label: 'Inconsistent assessment methods' },
    { value: 'nem_osszehangolt', label: 'Misaligned learning outcomes' },
    { value: 'egyuttmukodes_hianya', label: 'Lack of cooperation among teaching staff' },
    { value: 'egyeb', label: 'Other:' }
    ]
};

// 6.4
export const MAGYAR_ANGOL_OPTIONS = {
    hu: [
    { value: 'kivalo', label: 'Kiváló - a magyar és angol tananyag teljes mértékben, tartalmában és követelményrendszerében egyezik' },
    { value: 'jo', label: 'Jó - kisebb eltérések vannak, de a tanulási eredmények azonosak' },
    { value: 'reszben_osszehangolt', label: 'Részben összehangolt - tartalmi vagy követelménybeli eltérés több tárgynál megjelenik' },
    { value: 'problemas', label: 'Problémás - jelentős eltérések vannak a tananyagban vagy a követelményekben' },
    { value: 'kritikus', label: 'Kritikus - az eltérések a hallgatói eredményességet is hátráltathatják' }
    ],
    en: [
    { value: 'kivalo', label: 'Excellent – Hungarian- and English-language materials are fully aligned in content and assessment requirements' },
    { value: 'jo', label: 'Good – minor differences exist, but learning outcomes are identical' },
    { value: 'reszben_osszehangolt', label: 'Partially aligned – content- or requirement-related differences appear in several courses' },
    { value: 'problemas', label: 'Problematic – significant discrepancies exist in teaching materials or requirements' },
    { value: 'kritikus', label: 'Critical – discrepancies may adversely affect student performance' }
    ]
};